var exports = {
  "k": "x127c5a35--0f8f3d--container",
};

module.exports = exports;
